<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :headers="headers"
      :search="search"
      class="templates-table"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1]
      }"
      :items-per-page="50"
      :items="list"
    >
      <template v-slot:top>
        <div class="pa-4">
          <v-text-field
            hide-details=""
            label="Search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <create :item="item"></create>
          <remove-icon-button
            v-if="isAdmin"
            @click="remove(item)"
          ></remove-icon-button>
        </div>
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item.zipcode="{ item }">
        {{ getZip(item) }}
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { cmp } from "../../assets/js/firebase";
import RemoveIconButton from "../buttons/RemoveIconButton.vue";
import Create from "./Create.vue";
export default {
  components: { Create, RemoveIconButton },
  data() {
    return {
      lastDoc: null,
      search: "",
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "NAME / LANDMARK", value: "landmark" },
        { text: "ADDRESS", value: "address" },
        { text: "zipcode", value: "zipcode" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "100px";
        }
        list.push(doc);
      }
      return list;
    },
    list() {
      let list = this.$store.getters.cmp.map(item => {
        return item;
      });
      return list.sort((a, b) => a.landmark.localeCompare(b.landmark));
    }
  },
  methods: {
    getZip({ zipcode }) {
      let zipcodes = this.$store.getters.zipcodes.map(item => {
        let { zipcode, community, zone } = item;
        let doc = {};
        doc.id = item.id;
        doc.name = `${zipcode} / ${community} / ${zone}`;
        return doc;
      });

      let item = zipcodes.find(item => {
        return item.id == zipcode;
      });
      return item != null ? item.name : "";
    },
    remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this cmp",
        onConfirm: async () => {
          try {
            vm.$loader.show();
            cmp.doc(id).delete();
            vm.$loader.hide();
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
